import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { FaPrint } from 'react-icons/fa';

export const columnsDataClients = [
  {
    Header: 'Fecha',
    accessor: 'date',
  },
  {
    Header: 'Estado',
    accessor: 'warrantyStatus',
  },
  {
    Header: 'Tipo de garantía',
    accessor: 'warrantyType',
  },
  {
    Header: 'Matrícula',
    accessor: 'vehicle.plate',
  },
  {
    Header: 'Chasis',
    accessor: 'vehicle.chassisNumber',
  },
  {
    Header: 'Cliente',
    accessor: 'customer.name',
  },
  {
    Header: 'Operario',
    accessor: 'mechanic.name',
  },
  {
    Header: 'Petición del cliente',
    accessor: 'customerObservations',
    width: '16rem',
    maxWidth: '16rem',
    whiteSpace: 'normal',
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit',
      },
      {
        label: 'Eliminar garantía cancelada',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete',
      },
      {
        label: 'Recepción de garantía',
        icon: <FaPrint />,
        colorScheme: 'teal',
        type: 'print-reception',
      },
      {
        label: 'Garantía finalizada',
        icon: <FaPrint />,
        colorScheme: 'green',
        type: 'print-warranty',
      },
    ],
  },
];
